import prettyBytes from "pretty-bytes";

import Box from "ds/components/Box";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import Typography from "ds/components/Typography";
import { TerraformProviderVersionArtifact } from "types/generated";

const ProviderVersionArtifactsSizeCell = ({
  item: artifact,
  ...cellProps
}: TableSimpleCellProps<TerraformProviderVersionArtifact>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <Box align="center">
        <Typography tag="span" variant="p-body2">
          {prettyBytes(artifact.sizeBytes)}
        </Typography>
      </Box>
    </TableSimpleCell>
  );
};

export default ProviderVersionArtifactsSizeCell;
